export default __webpack_public_path__ + "static/media/logo-full.d53aeb71.svg";